// extracted by mini-css-extract-plugin
module.exports = {"phone":"c6e8ba5398--phone--1202f","hoverText":"c6e8ba5398--hoverText--2AW5b","simplified-phone":"c6e8ba5398--simplified-phone--PxCKI"};